function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import TextInput from "./TextInput";
import { InlineField, InlineFieldActions, InlineFieldAction, InlineFieldInfoAction } from "../internal/inlinefield";
import { Flex } from "./..";

var TextField = function TextField(_ref) {
  var icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      value = _ref.value,
      placeholder = _ref.placeholder,
      label = _ref.label,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      error = _ref.error,
      required = _ref.required,
      validated = _ref.validated,
      helperText = _ref.helperText,
      info = _ref.info,
      fullWidth = _ref.fullWidth,
      autoFocus = _ref.autoFocus;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isFocused = _React$useState2[0],
      setIsFocused = _React$useState2[1];

  var onFocusHandler = React.useCallback(function (event) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  }, [onFocus]);
  var onBlurHandler = React.useCallback(function (event) {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  }, [onBlur]);
  var onClearHandler = React.useCallback(function () {
    onChange('');
  }, [onChange]);
  var showPlaceholder = !value && isFocused;
  return /*#__PURE__*/React.createElement(InlineField, {
    size: size,
    label: label,
    icon: icon,
    disabled: disabled,
    isInputFocused: isFocused,
    value: value,
    error: error,
    helperText: helperText,
    required: required,
    validated: validated,
    fullWidth: fullWidth
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: value,
    size: size,
    disabled: disabled,
    placeholder: showPlaceholder ? placeholder : null,
    label: label,
    onChange: onChange,
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    autoFocus: autoFocus
  }), /*#__PURE__*/React.createElement(InlineFieldActions, null, info ? /*#__PURE__*/React.createElement(InlineFieldInfoAction, {
    info: info
  }) : null, value && !disabled ? /*#__PURE__*/React.createElement(InlineFieldAction, {
    icon: "cross_circle",
    onClick: onClearHandler
  }) : null)));
};

export { TextField };
export default TextField;